/**
 * Toggle Switch constants
 */

/** Toggle Switch visual style variants */
export const TOGGLE_SWITCH_VARIANT = {
  DEFAULT: 'default',
  SEGMENTED: 'segmented',
} as const;

export type ToggleSwitchVariant = (typeof TOGGLE_SWITCH_VARIANT)[keyof typeof TOGGLE_SWITCH_VARIANT];
